const UserTypes = {
  SET_USER_LOADING: 'USER/SET_USER_LOADING',
  SET_USER_FAILURE: 'USER/SET_USER_FAILURE',
  SET_USER_SUCCESS: 'USER/SET_USER_SUCCESS',
};

export default UserTypes;